import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";

interface V1Props {
    description?: string;
}

const V1 = ({ description }: V1Props) => {
    return description ? (
        <DA_Container>
            <div
                dangerouslySetInnerHTML={{
                    __html: description,
                }}
            />
        </DA_Container>
    ) : null;
};

export default V1;
